"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trees = function Trees(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 24 24", className: "custom-icon" }, props),
    _react2.default.createElement("path", {
      d: "M13.136509,0.210980799 C11.9984346,0.204079926 10.8406468,0.614782367 9.8800783,1.32583727 C8.68300611,0.729446528 7.06223294,0.594020338 5.56679758,1.0701074 C3.56743425,1.70662603 2.45181375,3.22634663 2.79172883,4.66952923 C2.2173351,4.90213204 1.78852312,5.24482433 1.59040353,5.6808452 C1.38775436,6.12683578 1.45463727,6.60719133 1.73487031,7.06571316 C1.3628705,7.32573894 1.03698189,7.64537729 0.780440433,8.01856594 C-0.299345448,9.58933471 0.262637577,11.5107501 2.03623763,12.3101773 C2.30341125,12.4305998 2.58309985,12.5187801 2.86869763,12.5761807 C3.32808165,14.2714189 5.31566481,15.7262233 7.98958359,16.1202356 C8.67097797,16.2206639 9.3446634,16.2427376 9.99258161,16.1987959 C9.97074314,17.9647794 9.89784919,19.9896598 9.89784919,19.9896598 C9.89784919,19.9896598 9.94407013,20.683883 9.75989515,21.2044875 C9.57572017,21.7250921 8.56271382,22.2108952 8.56271382,22.2108952 L13.9002869,22.2108952 C13.9002869,22.2108952 12.8872806,21.7250921 12.7031056,21.2044875 C12.5189309,20.683883 12.5645595,19.9896598 12.5645595,19.9896598 C12.5645595,19.9896598 12.4738956,17.5159028 12.4633141,15.6556378 C12.8084432,15.5181231 13.1326585,15.3585804 13.4283994,15.1772155 C14.1446553,15.3591288 14.915271,15.427772 15.7037539,15.3583976 C18.7599582,15.089515 20.9257383,12.8573799 20.5410186,10.3727917 C20.5395029,10.3631716 20.5378507,10.3533687 20.5362805,10.3437829 C21.5785008,9.46121842 22.2261856,8.2915937 22.2313996,7.04607995 C22.2414883,4.63847531 19.846492,2.83286895 16.828105,2.91869569 C16.5030439,1.66456499 15.5524155,0.673158719 14.1495269,0.333290761 C13.8175542,0.253082974 13.4777906,0.213322982 13.1364508,0.211266431 L13.136509,0.210980799 Z",
      id: "path-1"
    })
  );
};

exports.default = Trees;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/trees.js
// module id = ../lib/egov-ui-kit/custom-icons/trees.js
// module chunks = 504